import { styles } from 'consts';
import styled from 'styled-components';

const { textColorGray, fontMBank } = styles;

const MBank = styled.span`
  font-weight: 500;
`;

const SuppliedBy = styled.p`
  color: ${textColorGray};
  text-shadow: 0 0 7px rgba(0, 0, 0, 0.15);
  font-family: ${fontMBank};
  font-size: 0.75rem;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 0.0375rem;
  text-align: right;
  color: #afafaf;
  align-self: flex-end;
  padding-bottom: 0.4375rem;
`;

export { SuppliedBy, MBank };
